/** Seuil cadastre québécois rénové — aligné U3141LandRegisterService (LOT_NUMBER_RENOVATION_THRESHOLD). */
export const U3142_LOT_NUMBER_RENOVATION_THRESHOLD = 1_000_000;

/** Lot « territoire non rénové » : numéro extrait (chiffres) ≤ 1 000 000. */
export function u3142IsPreRenovationLotNumber(lot: string | undefined | null): boolean {
  if (lot == null || !String(lot).trim()) {
    return false;
  }
  const lotNum = Number(String(lot).replace(/[^0-9]/g, ''));
  return !Number.isNaN(lotNum) && lotNum <= U3142_LOT_NUMBER_RENOVATION_THRESHOLD;
}
